<template>
  <div class="userinfo-dialog">
    <el-dialog
      title="编辑信息"
      :visible.sync="dialogFormVisible1"
      @close="closedialog"
    >
      <el-form :rules="formRules" :model="form" ref="ruleForm">
        <el-form-item
          size="samll"
          label="公司名称(全称):"
          :label-width="formLabelWidth"
          prop="company"
        >
          <el-input
            v-model="form.company"
            autocomplete="off"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="姓名:"
          :label-width="formLabelWidth"
          prop="realname"
        >
          <el-input
            v-model="form.realname"
            autocomplete="off"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          label="手机号:"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.phone"
            maxlength="20"
            placeholder="请输入手机号"
          >
            <el-select
              v-model="form.phoneArea"
              slot="prepend"
              placeholder="请选择"
              style="width: 80px"
              filterable
              :filter-method="handleSearch"
            >
              <el-option
                v-for="item in optionsArr"
                :key="item.id"
                :label="item.code"
                :value="item.id"
              >
                <span style="float: left">{{ item.zh }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.code
                }}</span>
              </el-option>
            </el-select>
          </el-input>
        </el-form-item>

        <el-form-item
          required
          label="邮箱:"
          :label-width="formLabelWidth"
          prop="email"
        >
          <el-input
            :disabled="true"
            v-model="form.email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="公司地址:"
          :label-width="formLabelWidth"
          prop="company_addr"
        >
          <el-input
            v-model="form.company_addr"
            autocomplete="off"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="career" label="职位" :label-width="formLabelWidth">
          <el-input v-model="form.career" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item prop="industry" label="行业" :label-width="formLabelWidth">
          <el-select v-model="form.industry" placeholder="请选择职位" style="width: 100%">
            <el-option v-for="(item,index) in industryArr" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { User } from '@/api/api.js';
import phoneArr from '@/utils/phone.js';
import { industryArr } from '@/config'

export default {
  name: '',
  data () {
    let trim = (rule, value, cb) => {
      let reg = /\s+/g;
      if (reg.exec(value) !== null) {
        cb(new Error(`名称内不能包含空格!`));
      }
      cb();
    };
    let phoneValid = (rule, value, cb) => {
      if (!value) cb(new Error('手机号不能为空!'));
      if (!this.form.phoneArea) cb(new Error('请选择区号!'));
      if (value.length > 11) cb(new Error('手机号最多支持11位！'));
      let regx = /^[0-9]*$/;
      if (!regx.test(value)) {
        cb(new Error('手机号码必须为数字'));
      }
      cb();
    };
    return {
      form: {
        company: '',
        company_addr: '',
        realname: '',
        email: '1554417018@qq.com',
        phone: '',
        career: '',
        industry: '',
        phoneArea: '37' // 对应中国大陆信息的id
      },
      industryArr,
      optionsArr: [...phoneArr],
      formRules: {
        company: [
          { required: true, message: '公司名称(全称)不能为空!' },
          { max: 20, message: '公司名称(全称)长度不能超过20个字符!' },
          { validator: trim }
        ],
        realname: [
          { required: true, message: '姓名不能为空!' },
          { max: 20, message: '姓名长度不能超过20个字符!' },
          { validator: trim }
        ],
        company_addr: [
          { max: 20, message: '公司地址长度不能超过20个字符!' },
          { validator: trim }
        ],
        phone: [
          { required: true, message: '手机号不能为空!', trigger: 'change' },
          { validator: phoneValid, trigger: 'change' }
        ],
        career: [
          { required: true, message: '职位不能为空!' },
          { max: 20, message: '职位长度不能超过20个字符!' }
        ],
        industry: [
          { required: true, message: '行业不能为空!' }
        ]
      },
      dialogFormVisible1: false,
      formLabelWidth: '130px'
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogFormVisible (value) {
      this.dialogFormVisible1 = value;
      this.getuserInfo();
    }
  },
  methods: {
    handleSearch (value) {
      let result = phoneArr.filter((item, index) => {
        if (item.zh.indexOf(value) !== -1 || item.code.indexOf(value) !== -1) {
          return true;
        }
      });
      this.optionsArr = result;
    },
    closedialog (val) {
      this.$emit('closeMoule', this.dialogFormVisible1);
      this.$refs['ruleForm'].resetFields();
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let target = phoneArr.find((item) => item.id === this.form.phoneArea);
          let params = {
            company: this.form.company,
            company_addr: this.form.company_addr,
            realname: this.form.realname,
            email: this.form.email,
            phone: `+${target.code}${this.form.phone}`,
            career: this.form.career,
            industry: this.form.industry
          };
          User.editUserInfo(params).then((res) => {
            if (res.status === 10000) {
              this.dialogFormVisible1 = false;
              this.closedialog();
              this.$emit('reloaduserinfo', true);
              this.$message.success('用户信息编辑成功');
              // location.reload()
            } else if (res.status === 10002) {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getuserInfo () {
      User.getUserInfo({ send_email: false }).then(({ data }) => {
        if (data.status === 10000) {
          let phone = data.data.phone;
          let phoneArea = '37'; // 默认中国区号
          if (data.data.phone.indexOf('+86') !== -1) {
            phone = data.data.phone.substring(3);
          } else {
            let resultArr = this.optionsArr
              .filter((item, index) => {
                return phone.includes('+' + item.code);
              })
              .sort((a, b) => b.code.length - a.code.length);

            if (resultArr.length > 0) {
              phone = phone.replace('+' + resultArr[0].code, '');
              phoneArea = resultArr[0].id;
            }
          }
          this.form = {
            company: data.data.company || '',
            company_addr: data.data.company_addr || '',
            realname: data.data.realname || '',
            email: data.data.email || '',
            phone: phone || '',
            phoneArea: phoneArea,
            career: data.data.career || '',
            industry: data.data.industry || ''
          };
        } else if (data.status === 10001) {
          // this.$message.error('用户未登录，请先登录')
        } else {
          this.$message.error(data.message);
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.userinfo-dialog {
  /deep/.el-dialog__header {
    text-align: center;
    background: #4473f6;
    padding: 10px;
  }
}
/deep/.el-dialog {
  width: 40%;
}

/deep/.el-dialog__title {
  color: #fff;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.el-form-item {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 20px;
}
.el-button {
  margin-top: 20px;
  padding: 10px 60px;
}
/deep/.el-input__inner {
  height: 33px;
  line-height: 33px;
}
/deep/.el-dialog__title {
  font-size: 16px;
  font-weight: 500;
}

/deep/.el-dialog__headerbtn {
  top: 13px;
}
/deep/.el-input__icon {
  line-height: 33px;
}
/deep/.el-form-item__content .el-input-group {
  margin-top: 5px;
}
// /deep/ .el-form-item__error {
//   left: 27px;
// }
</style>
